import React, { DOMAttributes } from 'react';
import ReactDOM from 'react-dom';

const defaultProps = {
  size: 20,
};

const invalidSvgProps = ['svg', 'size', 'className'];

const IconBase = (props) => {
  const transformedProps = {
    ...defaultProps,
    ...props,
  };

  if (transformedProps.size) {
    transformedProps.width = transformedProps.size;
    transformedProps.height = transformedProps.size;
  }

  // if (transformedProps.className) {
  //   transformedProps.class = transformedProps.className;
  // }

  invalidSvgProps.forEach((p) => delete transformedProps[p]);

  const SvgComponent = props.svg;

  return SvgComponent ? <SvgComponent {...transformedProps} /> : null;
};

export default IconBase;
